<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M7 6v-1h11v1" />
    <path d="M7 19l4 0" />
    <path d="M13 5l-4 14" />
  </svg>
</template>

<script>
export default {
  name: 'IconTextField'
}
</script>
